module.exports = __webpack_public_path__ + "img/myFactory.9dc97885.svg";